import { render, staticRenderFns } from "./StatusInfoConf.vue?vue&type=template&id=6a7a7ffe"
import script from "./StatusInfoConf.vue?vue&type=script&lang=js"
export * from "./StatusInfoConf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports